"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'You can style it using some properties.';
var code = "import React from 'react';\nimport { FAB } from 'jsc-react-ui';\n\nconst Example = () => <FAB iconName=\"plus\" color=\"#f1c40f\" iconColor=\"#2c3e50\" />;";
exports.StylingExampleFAB = function () { return (React.createElement(common_1.Example, { title: "Styling", description: description, code: code },
    React.createElement(components_1.FAB, { iconName: "plus", color: "#f1c40f", iconColor: "#2c3e50" }))); };
exports.StylingExampleFAB.displayName = 'StylingExampleFAB';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentFABPage/StylingExampleFAB.tsx
// module id = 670
// module chunks = 0